export default {"src":"/_next/static/media/instagram.b36f633f.svg","height":32,"width":32};